export default function Services() {
  const services = [
    {
      icon: 'ri-vip-crown-line',
      title: 'VIP 프리미엄 서비스',
      description: '최고급 서비스와 프라이빗한 공간에서 특별한 시간을 보내실 수 있습니다. 전문 호스트들이 고객님의 만족을 위해 최선을 다합니다.',
      color: '#ec4899',
    },
    {
      icon: 'ri-user-star-line',
      title: '전문 호스트 매칭',
      description: '고객님의 취향과 스타일에 맞는 전문 호스트를 매칭해드립니다. 세련되고 매너있는 호스트들과 즐거운 대화를 나누세요.',
      color: '#06b6d4',
    },
    {
      icon: 'ri-calendar-check-line',
      title: '맞춤형 예약 시스템',
      description: '원하시는 시간과 서비스를 미리 예약하실 수 있습니다. 편리한 예약 시스템으로 대기 없이 바로 이용 가능합니다.',
      color: '#a855f7',
    },
  ];

  return (
    <section id="services" className="py-20 md:py-32 bg-black relative overflow-hidden">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] opacity-10 pointer-events-none" style={{ background: 'radial-gradient(ellipse, #ec4899 0%, transparent 70%)', filter: 'blur(80px)' }}></div>

      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        <div className="flex flex-col md:flex-row md:justify-between md:items-end mb-10 md:mb-16 gap-4">
          <div>
            <p className="text-sm font-medium tracking-[0.4em] uppercase mb-4" style={{ color: '#06b6d4', textShadow: '0 0 8px #06b6d4' }}>
              OUR SERVICES
            </p>
            <h2
              className="text-3xl md:text-5xl font-black leading-tight"
              style={{ fontFamily: "'Orbitron', sans-serif", color: '#fff', textShadow: '0 0 15px rgba(255,255,255,0.15)' }}
            >
              프리미엄<br />
              <span style={{ color: '#ec4899', textShadow: '0 0 15px #ec4899' }}>서비스</span>
            </h2>
          </div>
          <div className="md:max-w-md">
            <p className="text-sm md:text-base text-gray-400 leading-relaxed">
              고객님께 최상의 경험을 제공합니다
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="rounded-2xl p-6 md:p-8 border border-gray-800 hover:scale-105 transition-all duration-300 cursor-pointer group relative overflow-hidden"
              style={{ background: 'rgba(255,255,255,0.02)' }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLDivElement).style.borderColor = service.color;
                (e.currentTarget as HTMLDivElement).style.boxShadow = `0 0 30px ${service.color}33`;
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLDivElement).style.borderColor = '#1f2937';
                (e.currentTarget as HTMLDivElement).style.boxShadow = 'none';
              }}
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mb-5 md:mb-6 rounded-xl" style={{ background: `${service.color}15` }}>
                <i className={`${service.icon} text-3xl md:text-4xl`} style={{ color: service.color, textShadow: `0 0 12px ${service.color}` }}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3 md:mb-4">{service.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{service.description}</p>

              <div
                className="absolute bottom-0 left-0 h-0.5 w-0 group-hover:w-full transition-all duration-500"
                style={{ background: `linear-gradient(90deg, ${service.color}, transparent)` }}
              ></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
